export { default } from './EmailCaptureForm.vue';